







// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditPage.vue'
import ReadBasePage from '@/components/shared/ReadBasePage.vue'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'ReadPage',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadBasePage}
})
export default class ReadPage extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean
 

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
